import { render, staticRenderFns } from "./Meniu.vue?vue&type=template&id=119ae862&"
import script from "./Meniu.vue?vue&type=script&lang=js&"
export * from "./Meniu.vue?vue&type=script&lang=js&"
import style0 from "./Meniu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports